module.exports = __webpack_public_path__ + "10.e7a0bba2.png";


//////////////////
// WEBPACK FOOTER
// ./client/images/story/10.png
// module id = 686
// module chunks = 0